define.alias("shared/components/shared/ui/ember-drop", "settings/components/shared/ui/ember-drop");